package com.tovtalk.domain.entity

import kotlin.time.Instant

/**
 * Notification - התראה
 */
sealed class Notification {
    abstract val id: Int
    abstract val createdAt: Instant
    abstract val isRead: Boolean
    
    /**
     * Activity Notification - התראה על פעילות
     */
    data class Activity(
        override val id: Int,
        val type: ActivityType,
        val fromUser: User,
        val post: Post? = null,
        val comment: Comment? = null,
        override val createdAt: Instant,
        override val isRead: Boolean = false
    ) : Notification()
    
    /**
     * Admin Notification - התראה מהאדמין
     */
    data class Admin(
        override val id: Int,
        val title: String,
        val message: String,
        val imageUrl: String? = null,
        val actionUrl: String? = null,
        override val createdAt: Instant,
        override val isRead: Boolean = false
    ) : Notification()
}

/**
 * Activity Notification Type
 */
enum class ActivityType {
    LIKE_POST,
    LIKE_COMMENT,
    COMMENT_POST,
    REPLY_COMMENT,
    MENTION_POST,
    MENTION_COMMENT,
    FOLLOW_USER,
    NEW_MESSAGE
}
